/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */

import PaletteIconChevronDown from '@telus-uds/palette-koodo/build/rn/icons/ChevronDown'
import PaletteIconCheckCircleFilled from '@telus-uds/palette-koodo/build/rn/icons/CheckCircleFilled'
import PaletteIconExclamationOctagon from '@telus-uds/palette-koodo/build/rn/icons/ExclamationOctagon'
import PaletteIconChevronUp from '@telus-uds/palette-koodo/build/rn/icons/ChevronUp'
const theme = {
  appearances: {
    active: { type: 'state', values: [ true ] },
    focus: {
      description: 'Focus states for some input elements are well supported across web, RN, ios and android',
      type: 'state',
      values: [ true ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    inactive: {
      description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
      type: 'state',
      values: [ true ]
    },
    validation: {
      description: 'Validation states for form inputs',
      type: 'state',
      values: [ 'error', 'success', 'warning', 'feature' ]
    }
  },
  rules: [
    {
      if: { focus: true },
      tokens: { borderColor: '#7a3dfc', borderWidth: 3 }
    },
    {
      if: { validation: 'success' },
      tokens: {
        borderColor: '#1c7b2b',
        feedbackBackgroundColor: '#c5f2cc',
        validationIcon: PaletteIconCheckCircleFilled,
        validationIconColor: '#1c7b2b'
      }
    },
    {
      if: { validation: 'error' },
      tokens: {
        borderColor: '#c9370b',
        feedbackBackgroundColor: '#fcd3c6',
        validationIcon: PaletteIconExclamationOctagon,
        validationIconColor: '#c9370b'
      }
    },
    {
      if: { hover: true },
      tokens: { backgroundColor: '#efefef', borderColor: '#000000' }
    },
    {
      if: { inactive: true },
      tokens: {
        backgroundColor: '#efefef',
        borderColor: '#efefef',
        icon: null
      }
    },
    { if: { active: true }, tokens: { icon: PaletteIconChevronUp } }
  ],
  tokens: {
    backgroundColor: '#ffffff',
    borderColor: '#000000',
    borderRadius: 4,
    borderWidth: 1,
    color: '#000000',
    feedbackBackgroundColor: '#e0d8fc',
    fontName: 'StagSans',
    fontSize: 16,
    fontWeight: '400',
    height: 48,
    icon: PaletteIconChevronDown,
    iconColor: '#000000',
    iconSize: 24,
    outerBackgroundColor: 'rgba(0, 0, 0, 0)',
    outerBorderColor: 'rgba(0, 0, 0, 0)',
    outerBorderWidth: 2,
    paddingBottom: 12,
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 12,
    validationIcon: null,
    validationIconColor: 'rgba(0, 0, 0, 0)',
    validationIconSize: 24
  }
}
export default theme
